import { render } from "./indextenbanner.vue?vue&type=template&id=aed1a57e"
import script from "./indextenbanner.vue?vue&type=script&lang=js"
export * from "./indextenbanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__